import icon from 'vue-svgicon';

icon.register({
    'bold/arrow-button-right-2': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M21.058 10.289L5.014.564a2 2 0 0 0-3.036 1.711v19.45a2 2 0 0 0 3.037 1.711l16.043-9.725a2 2 0 0 0 0-3.422z"/>`,
    },
});
